import { render } from "./Theme.vue?vue&type=template&id=7bea7124&scoped=true"
import script from "./Theme.vue?vue&type=script&lang=js"
export * from "./Theme.vue?vue&type=script&lang=js"

import "./Theme.vue?vue&type=style&index=0&id=7bea7124&lang=less&scoped=true"

import exportComponent from "E:\\CODE\\jb-oa\\jb-oa-web\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7bea7124"]])

export default __exports__